import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { login, saveTokenInLocalStorage } from "../slice/providerAuth";
import ProviderHeader from "../../provider-header/components/index";
import ProviderFooter from "../../provider-footer/components/index";
// import ProviderHeader from "../../../../Clients/components/client-header/components/index";
// import ProviderFooter from "../../../../Clients/components/client-footer/components/index";
import Cookies from "js-cookie";

import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

const ProviderSignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    const savedEmail = Cookies.get("p_email");
    const savedPassword = Cookies.get("p_password");

    if (savedEmail && savedPassword) {
      setFormData({
        email: savedEmail,
        password: savedPassword,
      });

      const checkbox = document.getElementById("rememberMe");
      if (checkbox) checkbox.checked = true;
    }
  }, []);


  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = formData;
    const rememberMe = document.getElementById("rememberMe").checked;

    const result = await dispatch(login(formData));

    if (result.meta.requestStatus === "fulfilled") {
      const { access_token, expires_in, provider } = result.payload;

      saveTokenInLocalStorage(access_token, expires_in);
      localStorage.setItem("user_id", JSON.stringify(provider.id));
      localStorage.setItem("user_name", provider.company_name);

      // Set or remove cookie based on rememberMe
      if (rememberMe) {
        Cookies.set("p_email", email, { expires: 30 }); // 30 days
        Cookies.set("p_password", password, { expires: 30 }); // 30 days
      } else {
        Cookies.remove("p_email");
        Cookies.remove("p_password");
      }

      toast.success("Login successful!", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });

      navigate("/provider/panel/info");
    } else {
      toast.error("Login failed. Please check your credentials.", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  };



const handleGoogleLogin = async (googleUser) => {
  try {
    const res = await dispatch(login({ email: googleUser.email, name: googleUser.name, googleId: googleUser.sub }));

    if (res.meta.requestStatus === "fulfilled") {
      const { access_token, expires_in, provider } = res.payload;

      saveTokenInLocalStorage(access_token, expires_in);
      localStorage.setItem("user_id", JSON.stringify(provider.id));
      localStorage.setItem("user_name", provider.company_name);

      toast.success("Google Login successful!");
      navigate("/provider/panel/info");
    } else {
      toast.error("Google login failed on server.");
    }
  } catch (err) {
    toast.error("Google login error.");
  }
};

  return (
    <>
      <ProviderHeader />
      <main className="overflow-hidden">
        <section className="homepad-signin">  
          <div className="container">
            <div className="row">
              {/* 👶 Register Section */}
              <div className="col-md-6 left-panel-signin"
                  style={{
                    backgroundImage: "url('/assets/images/login-left.jpg')",
                    backgroundRepeat: "no-repeat"
                  }}>
                <div className="left-overlay-signin">
                  <h2 className="montserrat font-weight-bold lh-1 font-size-60">Welcome,  <span className="text-yellow">Professionals</span> & <span className="text-yellow">Educators</span></h2>
                  <div className="">
                  <p className="m-0 font-size-14 lh-base">The early years matter—and so does your role in shaping them. The Just Generation Foundation partners with therapists, educators, and healthcare professionals to deliver timely, effective support to families navigating developmental concerns. Join our growing network of licensed experts dedicated to improving outcomes for children ages 2–5. We offer streamlined onboarding, built-in verification, scheduling tools, billing integrations, and a referral-ready platform built with your practice in mind. <br />
                                        🔵 Let’s work together to build a stronger, earlier support system—one child at a time.</p>
                  </div>
                  {/* <div className="d-flex align-items-center mt-3">
                    <img src="https://randomuser.me/api/portraits/women/44.jpg" className="rounded-circle me-2" width="40" height="40" />
                    <div>
                      <div><strong className="montserrat font-weight-bold">Devon Lane</strong></div>
                      <small>Co-Founder, Design.co</small>
                    </div>
                  </div> */}
                </div>
              </div>

              {/* 🔐 Login Section */}
              <div className="col-md-6 bg-white d-flex align-items-center">
                <div className="login-form w-100">
                  <div className="logo text-center mb-4">
                    <img src="/assets/images/logo-login.png" className="img-fluid" />
                  </div>
                  <h3 className="font-weight-bold montserrat text-primary font-size-38 mb-3 lh-1 text-center">Welcome back ! Login</h3>
                  <p className="text-center text-dark">Lorem Ipsum is simply dummy text of the printing!</p>

                  <form className="mt-3 mt-xl-4 pt-xl-2 d-block" onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label text-primary mb-1 font-weight-semibold">Mobile Number or Email Address</label>
                      <input
                        type="text"
                        name="email"
                        className="form-control"
                        placeholder="Enter your email or mobile number"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label text-primary mb-1 font-weight-semibold">Password</label>
                      <input
                        type="password"
                        name="password"
                        className="form-control"
                        placeholder="Enter your password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div className="text-primary font-weight-semibold">
                        <input type="checkbox" id="rememberMe" className="me-1" />
                        <label htmlFor="rememberMe">  Remember Password</label>
                      </div>
                      <a href="/provider/forgot-password" className="text-decoration-none text-primary font-weight-semibold"><u>Forgot Password?</u></a>
                    </div>
                    <div className="pt-2 pt-xl-3">
                      <button className="btn btn-yellow w-100 mb-3 font-weight-bold font-size-18"><span className="d-block py-1">Login</span></button>
                    </div>
                    <div className="text-center">
                      <p className="mb-3 font-weight-medium font-size-16">Don’t have an account? <Link to="/provider/signup" className="text-decoration-none text-yellow font-weight-semibold"><u>Sign Up</u></Link></p>
                      <div className="social-icons d-flex justify-content-center">
                        <GoogleLogin
                          onSuccess={(credentialResponse) => {
                            const decoded = jwtDecode(credentialResponse.credential);
                            console.log("Google user:", decoded);

                            // You can now send the token or email to your backend
                            // Or use directly if you're doing token-based session
                            handleGoogleLogin(decoded);
                          }}
                          onError={() => {
                            toast.error("Google Sign-In failed");
                          }}
                        />

                        {/* <a href="#" className="text-decoration-none mx-2"><img src="/assets/images/iphone-icon.svg" className="img-fluid" alt="Apple" /></a> */}
                        {/* <a href="#" className="text-decoration-none"><img src="/assets/images/facebookicon.svg" className="img-fluid" alt="Facebook" /></a> */}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ProviderFooter />
      </main>
    </>
  );
};

export default ProviderSignIn;
